// extracted by mini-css-extract-plugin
export default {"stepDescription":"VerificationProcessStep_stepDescription__iswFy"};